import type { ICustomerOrder } from "@/data/model/Customer";
import { Signal, TypedSignal } from "@/data/util/Signal";

import { ViewTransition } from "@/app/controller/BaseController";
import { BaseController } from "@/app/controller/BaseController";

export interface IReceiptControllerTransitionData {
    order: ICustomerOrder;
    transition: ViewTransition;
    onGoBack?: { () };
}

export class ReceiptController extends BaseController {
    public onContinue?: { () };
    public onGoBack?: { () };

    // controller to view events
    static onShown = new TypedSignal<ICustomerOrder>();
    static onHidden = new Signal();

    // view to controller events
    static onGoBack = new Signal();
    static onViewUnmounted = new Signal();

    constructor() {
        super("receipt");
        ReceiptController.onGoBack.add(this.goBack, this);
    }

    protected onBecomeVisible(data: IReceiptControllerTransitionData) {
        ReceiptController.onShown.dispatch(data.order);
    }

    protected onBecomeInvisible() {
        ReceiptController.onHidden.dispatch();
    }

    protected goBack() {
        if (this.onGoBack) {
            this.onGoBack();
        }
    }

    protected continue() {
        if (this.onContinue) {
            this.onContinue();
        }
    }
}
